module.exports = __webpack_public_path__ + "static/media/traceability-provenance.7be5eb8e.svg";